import downloadDocument from './downloadDocument';
import downloadDocumentAdditionalInformation from './downloadDocumentAdditionalInformation';
import { getAdditionalFileTokenQuery } from './getAdditionalFileTokenQuery';
import uploadFileAttachmentsFromControlCommand from './uploadFileAttachmentsFromControlCommand';

export const CommonDocumentService = {
  uploadFileAttachmentsFromControlCommand,
  getAdditionalFileTokenQuery,
  downloadDocument,
  downloadDocumentAdditionalInformation,
};
